import React from 'react';
import { useInitUIStore } from './store/ui';
import { DataLoaderProxy } from './DataLoaderProxy';
import MainView from './pages/MainView';
import NodonSnackbarProvider from './providers/NodonSnackbarProvider';
import { AdapterLuxon } from '@mui/x-date-pickers/AdapterLuxon';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { useInitSentry } from './hooks/use-sentry.hook';
import { useSearchParams } from 'react-router-dom';
import { PrintView } from './pages/PrintView/PrintView';

const AppShared: React.FC = () => {
  useInitSentry();
  useInitUIStore();
  const [searchParams] = useSearchParams();
  const isPrint = searchParams.get('print') === '1';

  return (
    <NodonSnackbarProvider>
      <DataLoaderProxy isShared>
        <LocalizationProvider dateAdapter={AdapterLuxon}>
          {isPrint ? <PrintView /> : <MainView />}
        </LocalizationProvider>
      </DataLoaderProxy>
    </NodonSnackbarProvider>
  );
};

export default AppShared;
